import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const inputService = {
    load,isci,vrniPoId,
    
};
function isci(isci) {
    const requestOptions = {
        method: 'GET',
        //headers:authHeader(),
        
    };
return fetch(`${Vue.prototype.$config.apiUrl}/sredstva/?isci=${isci}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });
}


function vrniPoId(id) {
    const requestOptions = {
        method: 'GET',
        //headers:authHeader(),
    
    };
return fetch(`${Vue.prototype.$config.apiUrl}/sredstva/id?id=${id}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {

            
            return certifikat;
        });
}



function load(sezona,pridelovalecid) {
    const requestOptions = {
        method: 'GET',
       // headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/sredstva/`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });
}


